import { JSX } from "react"
import { ProviderCard, ProviderCardProps } from "./ProviderCard"
import { NETWORK_PROVIDER_CARD_HIGHLIGHT_BACKGROUND_COLOR, NETWORK_PROVIDER_CARD_HIGHLIGHT_BORDER_COLOR } from "./NetworkCoverageMapsColors";

export const NetworkProviderCard = (
  { provider, isSelected, onClick }: ProviderCardProps
): JSX.Element => {

  const highlightedStyles = isSelected ? 
    {
      backgroundColor: NETWORK_PROVIDER_CARD_HIGHLIGHT_BACKGROUND_COLOR,
      borderColor: NETWORK_PROVIDER_CARD_HIGHLIGHT_BORDER_COLOR,
      borderStyle: 'solid',
      borderWidth: '3px'
    } : {} ;

  return (
    <ProviderCard highlightedStyles={highlightedStyles} provider={provider} onClick={onClick}>
      <p><strong>Serves %:</strong> {provider.servesPercent}%</p>
    </ProviderCard>
  )
}

